import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { getHostname, RcEnvironment } from '../../env.config';
import { LoggerService } from '../../services/logging-service/logger.service';

import { EnvironmentConfigService } from './environment-config.service';

/**
 * @param env resolved cloud environment, or `null` if the hostname is not mapped — see
 * `determineConfigEnvironment`. The caller resolves it once and passes it in so the prod-mode
 * decision in `main.ts` and this loader cannot drift apart.
 */
export function provideEnvironmentConfig(env: RcEnvironment | null): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const logger = inject(LoggerService);
    const configService = inject(EnvironmentConfigService);

    if (!env) {
      const message = `No environment configured for hostname "${getHostname()}"`;
      logger.error(message);
      throw new Error(message);
    }

    return firstValueFrom(configService.loadConfig(env));
  });
}
